<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <ion-header class="transparent">
            <app-header [middleIconSize]="'bigger'" [middleIcon]="true" [hide930]="true"></app-header>
        </ion-header>
        <div class="subheader">
            <div class="subheader-text-2">{{ "__LEADERBOARD_BUSINESS_EXCELLENCE__" | translate }}</div>
            <div class="subheader-text-1">{{ "__LEADERBOARD_LEADERBOARD__" | translate }}</div>
        </div>
        <div class="shadow-container" *ngIf="!leaderboardData">
            <app-skeleton-leaderboard *ngFor="let el of ['50%','60%','40%','45%','50%','60%','40%','45%','50%','60%']; let i = index; let even = even"
                                      [ngClass]="{ even: even }" [even]="even" [width]="el"></app-skeleton-leaderboard>
        </div>
        <div class="shadow-container" *ngIf="!!leaderboardData"
                [ngClass]="{'raspberry-bg-opacity-medium': type === 'top',
                'green-bg-opacity-medium': type === 'cross',
                'orange-bg-opacity-medium': type === 'solutions',
                'blue-bg-opacity-medium': type === 'pricing',
                'grey-bg-opacity-medium': type === 'total'}">
            <ng-container *ngIf="type === 'top'">
                <div class="side-header raspberry-bg">
                    <img src="assets/icon/star.svg">
                    <div class="text">{{ "__LEADERBOARD_TOP_TEN__" | translate }}</div>
                </div>
                <div class="box">
                    <div class="table-header">
                        <div class="padding-left-small">#</div>
                        <div>{{ "__LEADERBOARD_TEAM__" | translate }}</div>
                        <div class="grid-phase">{{ "__LEADERBOARD_PHASE__" | translate }}</div>
                        <div></div>
                        <div class="grid-revenue padding-right-medium"><div class="revenue-text">{{ "__LEADERBOARD_REVENUE__" | translate }}<br><span style="font-weight: normal;">(£ {{ "__LEADERBOARD_IN_MILLIONS__" | translate }})</span></div></div>
                        <div></div>
                        <div></div>
                        <div class="table-header-box green-bg">1</div>
                        <div></div>
                        <div class="table-header-box orange-bg">2</div>
                        <div></div>
                        <div class="table-header-box blue-bg">3</div>
                    </div>
                    <div class="table-container">
                        <div class="grid-line-container" *ngFor="let el of leaderboardData | orderBy: 'total':'desc' | slice: 0:10; let i = index;"
                             [@enter]="{ value: '', params: { delay: i * 20 } }" [ngClass]="{'raspberry-bg-opacity-large': i === 0}">
                            <div class="grid-line border-bottom-raspberry">
                                <div class="left padding-left-small">{{i+1}}</div>
                                <div class="name left">{{el.full_name}}</div>
                                <div class="green-bg-opacity-medium">{{el.session1 | number:'1.0':'en-US'}}</div>
                                <div></div>
                                <div class="orange-bg-opacity-medium">{{el.session2 | number:'1.0':'en-US'}}</div>
                                <div></div>
                                <div class="blue-bg-opacity-medium">{{el.session3 | number:'1.0':'en-US'}}</div>
                                <div></div>
                                <div class="total padding-right-medium">{{el.total | number:'1.0':'en-US'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="type === 'phase1'">
                <div class="side-header green-bg">
                    <img src="assets/icon/one.svg">
                    <div class="text">{{ "__LEADERBOARD_SELLING_A_STORY__" | translate }}</div>
                </div>
                <div class="box">
                    <div class="table-header">
                        <div class="padding-left-small">#</div>
                        <div>{{ "__LEADERBOARD_TEAM__" | translate }}</div>
                        <div></div>
                        <div></div>
                        <div class="grid-revenue padding-right-medium"><div class="revenue-text">{{ "__LEADERBOARD_REVENUE__" | translate }}<br><span style="font-weight: normal;">(£ {{ "__LEADERBOARD_IN_MILLIONS__" | translate }})</span></div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="table-container green-bg-opacity-large">
                        <div class="grid-line-container" *ngFor="let el of leaderboardData | orderBy: 'session1':'desc' | slice: 0:10; let i = index;"
                             [@enter]="{ value: '', params: { delay: i * 20 } }">
                            <div class="grid-line border-bottom-green">
                                <div class="left padding-left-small">{{i+1}}</div>
                                <div class="name left">{{el.full_name}}</div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div class="total padding-right-medium">{{el.session1 | number:'1.0':'en-US'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="type === 'phase2'">
                <div class="side-header orange-bg">
                    <img src="assets/icon/two.svg">
                    <div class="text">{{ "__LEADERBOARD_OWNING_A_DEAL__" | translate }}</div>
                </div>
                <div class="box">
                    <div class="table-header">
                        <div class="padding-left-small">#</div>
                        <div>{{ "__LEADERBOARD_TEAM__" | translate }}</div>
                        <div></div>
                        <div></div>
                        <div class="grid-revenue padding-right-medium"><div class="revenue-text">{{ "__LEADERBOARD_REVENUE__" | translate }}<br><span style="font-weight: normal;">(£ {{ "__LEADERBOARD_IN_MILLIONS__" | translate }})</span></div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="table-container orange-bg-opacity-large">
                        <div class="grid-line-container" *ngFor="let el of leaderboardData | orderBy: 'session2':'desc' | slice: 0:10; let i = index;"
                             [@enter]="{ value: '', params: { delay: i * 20 } }">
                            <div class="grid-line border-bottom-orange">
                                <div class="left padding-left-small">{{i+1}}</div>
                                <div class="name left">{{el.full_name}}</div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div class="total padding-right-medium">{{el.session2 | number:'1.0':'en-US'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="type === 'phase3'">
                <div class="side-header blue-bg">
                    <img src="assets/icon/three.svg">
                    <div class="text">{{ "__LEADERBOARD_MASTERING_THE_MESSAGE__" | translate }}</div>
                </div>
                <div class="box">
                    <div class="table-header">
                        <div class="padding-left-small">#</div>
                        <div>{{ "__LEADERBOARD_TEAM__" | translate }}</div>
                        <div></div>
                        <div></div>
                        <div class="grid-revenue padding-right-medium"><div class="revenue-text">{{ "__LEADERBOARD_REVENUE__" | translate }}<br><span style="font-weight: normal;">(£ {{ "__LEADERBOARD_IN_MILLIONS__" | translate }})</span></div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div class="table-container blue-bg-opacity-large">
                        <div class="grid-line-container" *ngFor="let el of leaderboardData | orderBy: 'session3':'desc' | slice: 0:10; let i = index;"
                             [@enter]="{ value: '', params: { delay: i * 20 } }">
                            <div class="grid-line border-bottom-blue">
                                <div class="left padding-left-small">{{i+1}}</div>
                                <div class="name left">{{el.full_name}}</div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div class="total padding-right-medium">{{el.session3 | number:'1.0':'en-US'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="type === 'total'">
                <div class="side-header grey-bg">
                    <img src="assets/icon/pound.svg">
                    <div class="text">{{ "__LEADERBOARD_TOTAL_REVENUE__" | translate }}</div>
                </div>
                <div class="box">
                    <div class="table-header">
                        <div class="padding-left-small">#</div>
                        <div>{{ "__LEADERBOARD_TEAM__" | translate }}</div>
                        <div class="grid-phase">{{ "__LEADERBOARD_PHASE__" | translate }}</div>
                        <div></div>
                        <div class="grid-revenue padding-right-medium"><div class="revenue-text">{{ "__LEADERBOARD_REVENUE__" | translate }}<br><span style="font-weight: normal;">(£ {{ "__LEADERBOARD_IN_MILLIONS__" | translate }})</span></div></div>
                        <div></div>
                        <div></div>
                        <div class="table-header-box green-bg">1</div>
                        <div></div>
                        <div class="table-header-box orange-bg">2</div>
                        <div></div>
                        <div class="table-header-box blue-bg">3</div>
                    </div>
                    <div class="table-container">
                        <div class="grid-line-container" *ngFor="let el of leaderboardData | orderBy: 'total':'desc' | slice: 0:10; let i = index;"
                             [@enter]="{ value: '', params: { delay: i * 20 } }" [ngClass]="{'grey-bg-opacity-large': i === 0}">
                            <div class="grid-line border-bottom-grey">
                                <div class="left padding-left-small">{{i+1}}</div>
                                <div class="name left">{{el.full_name}}</div>
                                <div class="green-bg-opacity-medium">{{el.session1 | number:'1.0':'en-US'}}</div>
                                <div></div>
                                <div class="orange-bg-opacity-medium">{{el.session2 | number:'1.0':'en-US'}}</div>
                                <div></div>
                                <div class="blue-bg-opacity-medium">{{el.session3 | number:'1.0':'en-US'}}</div>
                                <div></div>
                                <div class="total padding-right-medium">{{el.total | number:'1.0':'en-US'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</ion-content>
